module.exports = __webpack_public_path__ + "img/icon-coffee.6d241e30.svg";